import ajax from '../http/ajax'
/**
 *
 * param {sstore_id: '', // 门店id
    activity_id: '', // 活动id
    floor_id: '', // 楼层id
    search_keyword: '', // 搜索关键字
    page：'',//页码
    pagesize：'', //单页加载数
 */
export const getGoodsList = param => {
    return ajax.get('getGoodsList', param)
}
